<template>
    <transition name="cookie-fade">
        <div v-if="isVisible" class="cookie-banner-wrapper">
            <div class="cookie-banner-container">
                <div class="cookie-banner-content">
                    <div class="cookie-icon-wrap">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EBB970" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"></path>
                            <path d="M8.5 8.5v.01"></path>
                            <path d="M16 15.5v.01"></path>
                            <path d="M12 12v.01"></path>
                            <path d="M11 17v.01"></path>
                            <path d="M7 13v.01"></path>
                        </svg>
                    </div>
                    <p class="cookie-banner-text">
                        Мы используем файлы cookie для анализа посещаемости и оптимизации работы сайта.
                        Продолжая использовать сайт, вы соглашаетесь на обработку cookies в соответствии с
                        нашей политикой конфиденциальности.
                    </p>
                </div>
                <div class="cookie-banner-actions">
                    <button type="button" class="cookie-accept-btn" @click="acceptCookies">
                        Принять
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { trackConsent } from '@/utils/analytics';

export default {
    name: "CookieBanner",
    data() {
        return {
            hasConsent: false
        };
    },
    computed: {
        ...mapGetters(['getUserAge']),
        isAgeConfirmed() {
            // Пользователь прошел возрастной гейт
            return Boolean(this.getUserAge || localStorage.getItem('userAge'));
        },
        isVisible() {
            return this.isAgeConfirmed && !this.hasConsent;
        }
    },
    mounted() {
        const savedConsent = localStorage.getItem('cookieConsent');
        if (savedConsent === 'granted') {
            this.hasConsent = true;
            trackConsent(true);
        }
    },
    methods: {
        acceptCookies() {
            localStorage.setItem('cookieConsent', 'granted');
            this.hasConsent = true;
            trackConsent(true);
        }
    }
};
</script>

<style scoped>
.cookie-banner-wrapper {
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    margin: 0 auto;
    max-width: 860px;
    z-index: 9999;
    pointer-events: none;
}

.cookie-banner-container {
    pointer-events: auto;
    background: rgba(14, 14, 14, 0.94);
    border: 1px solid rgba(235, 185, 112, 0.4);
    backdrop-filter: blur(12px);
    border-radius: 12px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
}

.cookie-banner-content {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
}

.cookie-icon-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cookie-banner-text {
    font-family: var(--font-family, sans-serif);
    font-size: 13px;
    line-height: 1.45;
    color: #F2E4B5;
    margin: 0;
}

.cookie-banner-actions {
    flex-shrink: 0;
}

.cookie-accept-btn {
    background: linear-gradient(135deg, #EBB970 0%, #BA893D 100%);
    color: #020202;
    font-family: var(--font-family-bold, sans-serif);
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.04em;
    padding: 9px 24px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.cookie-accept-btn:hover {
    transform: translateY(-1px);
    filter: brightness(1.1);
    box-shadow: 0 4px 12px rgba(235, 185, 112, 0.35);
}

.cookie-accept-btn:active {
    transform: translateY(0);
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
    transition: opacity 0.35s ease, transform 0.35s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

@media (max-width: 768px) {
    .cookie-banner-wrapper {
        bottom: 12px;
        left: 12px;
        right: 12px;
    }

    .cookie-banner-container {
        flex-direction: column;
        align-items: stretch;
        gap: 14px;
        padding: 14px 16px;
    }

    .cookie-banner-text {
        font-size: 12px;
    }

    .cookie-accept-btn {
        width: 100%;
        padding: 10px;
        text-align: center;
    }
}
</style>
